import React, { Component } from 'react'

class OfferHeader extends Component {
    constructor(props){
        super(props);
    }

    render(){
        const { title, children } = this.props;

        return (
            <main>
                <div className="mainBannerContainer">
                    <div className="mainBannerContent homePage">
                        <div className="row">
                            <div className="col-lg-12">
                            <h1>{title}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bodyContainer">
                    <div className="enrol-container">
                        {children && typeof children === 'function' && children()}
                    </div>
                </div>
            </main>
        )
    }
}
export default OfferHeader;